import { render, staticRenderFns } from "./PredjeniKilometriVozacaIVozila.vue?vue&type=template&id=03005134&scoped=true&"
import script from "./PredjeniKilometriVozacaIVozila.vue?vue&type=script&lang=ts&"
export * from "./PredjeniKilometriVozacaIVozila.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03005134",
  null
  
)

export default component.exports